// The character-limit guard used by the fill-side TextField (rendered by
// FillThresholdReport in the inspector's InspectionEditor). A form-builder admin
// sets `Max Length` (`max`) on a field; when the inspector fills the report,
// any input longer than `max` is rejected.
//
// `max` is stored as a string by the builder (e.g. '5'); an empty/undefined
// value means "the admin didn't set a limit", in which case we fall back to
// DEFAULT_MAX_LENGTH rather than accepting unbounded input. That matches the
// Information / Gate Code textareas on the Details tab, which are natively
// capped at 2000, and keeps a runaway paste out of the generated report.

// Safety cap applied when a field has no explicit Max Length. The fill-side
// TextField only shows its `count/max` counter for an explicit limit, so this
// stays invisible in normal use.
export const DEFAULT_MAX_LENGTH = 2000;

export const exceedsMaxLength = (value: string, max?: string | number): boolean => {
  const explicit = max !== undefined && max !== null && `${max}`.trim() !== '';
  // A non-numeric or non-positive `max` is treated as "not configured" — an
  // admin typing '0' or junk should not lock the field so it accepts nothing.
  const parsed = explicit ? Number(max) : NaN;
  const cap = Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_MAX_LENGTH;

  return `${value ?? ''}`.length > cap;
};
